import { render, staticRenderFns } from "./threevjia-inPaint.vue?vue&type=template&id=67f98620"
import script from "./threevjia-inPaint.vue?vue&type=script&lang=js"
export * from "./threevjia-inPaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports